import React, { useState } from 'react'
import { Button, ButtonGroup, Row, Col, Form } from 'react-bootstrap'
import api from '../api/api'
import swal from 'sweetalert'
import { useTranslation } from "react-i18next";
import { useEffect } from 'react';
import { Modal } from "react-bootstrap"



const SensorList = ({ sensorsData, Sensors }) => {

    const { t } = useTranslation();


    const [toggle, setToggle] = useState(false);


    const [msgServer, setMsg] = useState("")

    const [classMsg, setCmsg] = useState("")
    const [displayMsg, setDispMsg] = useState("hide")
    const [iconMsg, setIconMsg] = useState("info")

    const [code, setCode] = useState('')
    const [description, setDescription] = useState('')
    const [zoneUid, setZone] = useState('')
    const [fieldId, setField] = useState('')
    const [zones, setZonesList] = useState([])
    const [fields, setFieldsList] = useState([])
    const [codeErr, setCodeErr] = useState('')


    const [SingleSensor, setSingleSensor] = useState([])

    const getSingleSensor = async (sensorUid) => {

        let data = {
            sensor_uid: sensorUid,
        }

        await api.post('/sensor', data)
            .then(res => {
                let SensorData = res.data.sensor
                setSingleSensor(SensorData)
                setCode(SensorData[0].code)
                setDescription(SensorData[0].description)
                setZone(SensorData[0].zone_id)
                setField(SensorData[0].field_id)
            }).catch(error => {
                swal({
                    title: t("Error"),
                    icon: "error",

                });

            })
        setToggle(!toggle)

    }


    const validate = () => {
        let codeErr = '';

        if (!code) {
            codeErr = t('field_cannot_be_blank', { defaultValue: 'Cannot be blank!' });
            setCodeErr(codeErr)
            return false;
        } else {
            setCodeErr("")
            return true;
        }

    };

    const handleEdit = (sensorUid) => {


        let user = JSON.parse(localStorage.getItem('user') || '{}');
        let user_uid = user.id

        let data = {
            code: code,
            user_uid,
            sensor_uid: sensorUid,
            field_id: fieldId,
            zone_id: zoneUid,
        }

        let isValid = validate()

        if (isValid) {

            api.post('/sensor/edit-sensor', data)
                .then(response => {
                    if (response.data.type == "success") {
                        swal(`${t('sensor_updated')}`, {
                            icon: "success",
                        });
                        setToggle(false)
                        Sensors();
                    }
                    if (response.data.type && response.data.type == "danger") {
                        swal({
                            icon: 'error',
                            title: t('Oops...'),
                            text: t('Error')
                        })
                        return false;
                    }
                }).catch(error => {
                    swal({
                        icon: 'error',
                        title: t('Oops...'),
                        text: t('Error')
                    })
                })
        }

    }


    const handleDelete = async sensorUid => {



        let data = {
            sensor_uid: sensorUid,
        }
        await api.delete('/sensor/delete-sensor', { data: data })
            .then(response => {
                if (response.data.type && response.data.type == "danger") {
                    swal({
                        title: `${t('cannot_delete')}`,
                        icon: "warning",
                    });
                }
                if (response.data.type == "success") {
                    Sensors()
                    setMsg('delete_success_sensor')
                    setCmsg("success")
                    setDispMsg("show")
                    setIconMsg("check")
                    hideMsg()
                }
            }).catch(error => {
                swal({
                    title: `${t('cannot_delete')}`,
                    icon: "error",
                    text: t('Error')

                });
            })
    }
    const hideMsg = () => {
        setTimeout(() => {
            setDispMsg("hide")
        }, 3000);

    }


    const confirmDelete = sensorUid => {

        swal({
            title: `${t('are_you_sure')}`,
            text: `${t('confirm_delete')}`,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((Delete) => {
                if (Delete) {
                    handleDelete(sensorUid)
                    swal(`${t('delete_success_sensor')}`, {
                        icon: "success",
                    });
                }
            }).catch(error => {
                swal({
                    title: `${t('cannot_delete')}`,
                    icon: "error",
                    text: t('Error')
                });
            })

    }

    const fetchDataSensor = async (sensorUid) => {
        await api.post('/sensor/activate-synch', { sensor_uid: sensorUid })
            .then(response => {
                if (response.data.type === "success") {
                    swal(`${t('sensor_updated')}`, {
                        icon: "success",
                    });
                    Sensors()
                }
                if (response.data.type === "danger") {
                    swal({
                        icon: "error",
                        text: t('Error')
                    });
                }
            })
    }

    useEffect(() => {

        const getDataZones = async () => {
            await api.get('/zone/zones').then(res => {
                const newDataZone = res.data.farms;
                let Zones = [];
                newDataZone.map(item => {
                    let fields = item.fields;
                    if (fields) {
                        fields.map(itemZone => {
                            let zones = itemZone.zones;
                            if (zones) {
                                zones.map(i => {
                                    Zones.push({
                                        id: i.id,
                                        name: i.name,
                                        Uid: i.uid
                                    })
                                })
                            }
                        })
                    }
                })

                setZonesList(Zones)
            })
        }

        const getDataFields = async () => {
            await api.get('/field/fields').then(res => {
                const newData = res.data.farms;
                let Fields = [];
                newData.map(item => {
                    let fields = item.fields
                    if (fields) {
                        fields.map(itemfield => {
                            Fields.push({
                                name: itemfield.name,
                                id: itemfield.id,
                            });
                        })
                    }
                });
                setFieldsList(Fields)
            })
        }

        getDataFields()
        getDataZones()
    }, [])

    return (
        <div className="sensor-list-content">
            <div className={`sensor-list-alert alert alert-${classMsg} fade ${displayMsg}`}>
                <i className={`fa fa-${iconMsg}`} aria-hidden="true" /> {t(msgServer)}
            </div>
            <div className="sensor-table-wrap">
            <table className="sensor-table table mb-0">
                <thead>
                    <tr>
                        <th scope="col" className="border-0">{t('sensor_code')}</th>
                        <th scope="col" className="border-0 sensor-actions-heading">{t('actions')}</th>

                    </tr>
                </thead>
                <tbody>
                    {
                        sensorsData.map((item, indx) => {
                            return (

                                <tr key={item.uid || indx}>
                                    <td>{item.code}</td>

                                    <td>
                                        <ButtonGroup size="sm" className="sensor-action-buttons">
                                            {
                                                item.synchronized === "0"
                                                    ?
                                                    <Button className="is-sync" onClick={() => fetchDataSensor(item.uid)} title={t('synchronize')}><i className="fas fa-sync-alt" aria-hidden="true" /></Button>
                                                    :
                                                    null
                                            }
                                            <Button className="is-edit" onClick={() => getSingleSensor(item.uid)} title={t('edit')}><i className="fas fa-pen" aria-hidden="true" /></Button>
                                            <Button className="is-delete" onClick={() => confirmDelete(item.uid)} title={t('delete')}><i className="fas fa-trash" aria-hidden="true" /></Button>
                                        </ButtonGroup>
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
            {sensorsData.length === 0 && (
              <div className="sensor-table-empty">
                <span><i className="fas fa-broadcast-tower" aria-hidden="true" /></span>
                <strong>{t("sensor_empty_title", { defaultValue: "Aucun capteur" })}</strong>
                <p>{t("sensor_empty_help", { defaultValue: "Ajoutez votre premier capteur pour commencer le suivi." })}</p>
              </div>
            )}
            </div>
            {
                SingleSensor.map((item) => (
                    <Modal key={item.uid || item.id} size="lg" dialogClassName="sensor-edit-modal" centered show={toggle} onHide={() => setToggle(false)}>
                        <Modal.Header className="sensor-edit-header">

                            <div className="sensor-edit-title">
                              <span><i className="fas fa-pen" aria-hidden="true" /></span>
                              <div>
                                <small>SMARTFARM</small>
                                <h2>{t('edit_sensor')}</h2>
                              </div>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: "10px"

                                }}
                            >
                                <Button
                                    // theme="success"
                                    className="sensor-modal-save"
                                    onClick={() => handleEdit(item.uid)}
                                >
                                    <i className="fa fa-check" aria-hidden="true" />
                                    {t('save')}
                                </Button>
                                <Button
                                    // theme="success"
                                    className="sensor-modal-cancel"
                                    onClick={() => setToggle(false)}

                                >
                                    <i className="fa fa-times" aria-hidden="true" />
                                    {t('cancel')}
                                </Button>
                            </div>

                        </Modal.Header>
                        <Modal.Body className="sensor-edit-body">
                            <Form className="sensor-edit-form">
                                <Row className="sensor-edit-grid">
                                    <Col lg="3" md="12" sm="12" className="form-group">
                                        <label htmlFor={`edit-sensor-code-${item.id}`}>{t('sensor_code')}</label>
                                        <Form.Control
                                            id={`edit-sensor-code-${item.id}`}
                                            key={item.id}
                                            placeholder={t('sensor_code')}
                                            value={code}
                                            onChange={(e) => setCode(e.target.value)}
                                            className={`${codeErr ? 'is-invalid' : ""}`}

                                        />
                                        <div className="invalid-feedback">{codeErr}</div>

                                    </Col>
                                    <Col lg="4" md="12" sm="12" className="form-group">
                                        <label htmlFor={`edit-sensor-field-${item.id}`}>{t('name_field')}</label>
                                        <Form.Select
                                            id={`edit-sensor-field-${item.id}`}
                                            key={item.id}
                                            placeholder={t('name_field')}
                                            value={fieldId}
                                            onChange={(e) => setField(e.target.value)}

                                        >
                                            <option value="">{t('select_field')}</option>

                                            {
                                                fields.map(field => {
                                                    return (
                                                        <option key={field.id} value={field.id}>{field.name}</option>
                                                    )
                                                })
                                            }
                                        </Form.Select>
                                    </Col>
                                    <Col lg="4" md="12" sm="12" className="form-group">
                                        <label htmlFor={`edit-sensor-zone-${item.id}`}>{t('name_zone')}</label>
                                        <Form.Select
                                            id={`edit-sensor-zone-${item.id}`}
                                            key={item.id}
                                            placeholder={t('name_zone')}
                                            value={zoneUid}
                                            onChange={(e) => setZone(e.target.value)}

                                        >
                                            <option value="">{t('select_zone')}</option>

                                            {

                                                zones.map(zone => {

                                                    return (
                                                        <option key={zone.id} value={zone.id}>{zone.name}</option>

                                                    )
                                                })
                                            }
                                        </Form.Select>
                                    </Col>
                                </Row>
                                <Form.Group className="sensor-edit-description">
                                    <label htmlFor={`edit-sensor-description-${item.id}`}>{t('desc')}</label>
                                    <textarea
                                        id={`edit-sensor-description-${item.id}`}
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        className="form-control"
                                        placeholder={t('desc')}

                                    ></textarea>
                                </Form.Group>
                            </Form>

                        </Modal.Body>
                    </Modal>

                ))
            }
        </div>
    )
}

export default SensorList
